export default theme => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.common.white,
    overflowX: 'hidden',
  },
  grid: {
    width: 'auto',
    minHeight: 'calc(100vh - 90px)',
    marginTop: '90px',
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  topbar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  footer: {
    width: 'auto',
    padding: '32px',
    backgroundColor: theme.palette.common.white,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
});
